export enum ImagingType {
  ULTRASOUNDS = "Ultrasounds",
  X_RAYS = "X-Rays",
  CT_SCANS = "CT Scans",
  MRI = "MRI",
  NUCLEAR_MEDICINE = "Nuclear Medicine",
  DEXA = "DEXA",
  RETINA_EYE_EXAM = "Retina Eye Exam",
  ECHO = "Echo",
  CARDIAC_TESTS = "Cardiac Tests",
  EKG = "EKG",
  SPIROMETRY = "Spirometry",
  COLONOSCOPY = "Colonoscopy",
  SIGMOIDOSCOPY = "Sigmoidoscopy",
  MAMMOGRAM = "Mammogram",
  PET = "PET",
  POLYSOMNOGRAM = "Polysomnogram",
  HOME_SLEEP_STUDY = "Home Sleep Study",
  ELECTROENCEPHALOGRAM = "Electroencephalogram",
  ELECTROMYOGRAM = "Electromyogram",
  EVOKED_POTENTIAL = "Evoked Potential",
  AUDIOGRAM = "Audiogram",
  TYMPANOGRAM = "Tympanogram",
  RADIOLOGY_INTERPRETATION_REPORT = "Radiology Interpretation Report",
  OTHER = "Other",
  LINK_TO_RECORDS_IMAGING = "Link to Records/Imaging",
}

/** Canonical values for the multi-select imagingResults.bodyParts field. */
export enum ImagingBodyPart {
  ABDOMEN = "Abdomen",
  ABDOMINAL_AORTA = "Abdominal Aorta",
  ANKLE = "Ankle",
  AORTA = "Aorta",
  BLADDER = "Bladder",
  BONE = "Bone",
  BRAIN = "Brain",
  BREAST = "Breast",
  CAROTID_ARTERY = "Carotid Artery",
  CERVICAL_SPINE = "Cervical Spine",
  CHEST = "Chest",
  COLON = "Colon",
  CORONARY_ARTERIES = "Coronary Arteries",
  EAR = "Ear",
  ELBOW = "Elbow",
  EXTREMITY = "Extremity",
  EYE = "Eye",
  FACIAL_BONES = "Facial Bones",
  FINGER = "Finger",
  FOOT = "Foot",
  HAND = "Hand",
  HEAD = "Head",
  HEART = "Heart",
  HEPATOBILIARY = "Hepatobiliary",
  HIP = "Hip",
  ILIAC_VESSELS = "Iliac Vessels",
  KIDNEY = "Kidney",
  KNEE = "Knee",
  LOWER_EXTREMITY = "Lower Extremity",
  LUMBAR_SPINE = "Lumbar Spine",
  LUMBOSACRAL_SPINE = "Lumbosacral Spine",
  MAXILLOFACIAL = "Maxillofacial",
  NECK = "Neck",
  ORBITS = "Orbits",
  PARATHYROID = "Parathyroid",
  PELVIS = "Pelvis",
  PROSTATE = "Prostate",
  RENAL_ARTERIES = "Renal Arteries",
  RETINA = "Retina",
  RETROPERITONEUM = "Retroperitoneum",
  RIBS = "Ribs",
  SACROILIAC_JOINT = "Sacroiliac Joint",
  SCROTUM = "Scrotum",
  SHOULDER = "Shoulder",
  SINUSES = "Sinuses",
  SPINE = "Spine",
  THORACIC_SPINE = "Thoracic Spine",
  THORACOLUMBAR_SPINE = "Thoracolumbar Spine",
  THYROID = "Thyroid",
  TOE = "Toe",
  TRANSPLANTED_KIDNEY = "Transplanted Kidney",
  UPPER_EXTREMITY = "Upper Extremity",
  URETER = "Ureter",
  WRIST = "Wrist",
}

/** Canonical values used by body-part laterality fields. */
export enum ImagingBodyPartLaterality {
  LEFT = "Left",
  RIGHT = "Right",
  BILATERAL = "Bilateral",
  UNILATERAL = "Unilateral",
  OTHER = "Other",
}

/** Canonical configured options for imagingResults.procedure; the field remains free-text compatible. */
export enum ImagingProcedure {
  ANGIOGRAM_CTA = "Angiogram/CTA",
  ANGIOGRAM_MRA = "Angiogram/MRA",
  ANKLE_BRACHIAL_INDEX = "Ankle Brachial Index",
  ARTERIAL = "Arterial",
  BARIUM_SWALLOW_STUDY = "Barium Swallow Study",
  BONE_AGE = "Bone Age",
  CALCIUM_SCORE = "Calcium Score",
  COLONOGRAPHY = "Colonography",
  ECHOCARDIOGRAM = "Echocardiogram",
  EVENT_MONITOR = "Event Monitor",
  EXERCISE_STRESS_TEST = "Exercise Stress Test",
  FLUORESCEIN_ANGIOGRAM = "Fluorescein Angiogram",
  HOLTER_MONITOR = "Holter Monitor",
  LOWER_GI_SERIES = "Lower GI Series",
  LOW_DOSE_CT = "Low-Dose CT",
  MODIFIED_BARIUM_SWALLOW = "Modified Barium Swallow",
  MYOCARDIAL_PERFUSION = "Myocardial Perfusion",
  PACEMAKER_MONITORING = "Pacemaker Monitoring",
  PHARMACOLOGIC_STRESS_TEST = "Pharmacologic Stress Test",
  RENAL_SCAN = "Renal Scan",
  SPECT = "SPECT",
  TILT_TABLE_TEST = "Tilt Table Test",
  UPPER_GI_SERIES = "Upper GI Series",
  UROGRAM = "Urogram",
  V_Q_SCAN = "V/Q Scan",
  VEIN_MAPPING = "Vein Mapping",
  VENOUS = "Venous",
  VISUAL_FIELD_TEST = "Visual Field Test",
}

/** Canonical configured options for imagingResults.studyType; the field remains free-text compatible. */
export enum ImagingStudyType {
  AAA = "AAA",
  TWELVE_LEAD = "12-Lead",
  FOUR_OR_MORE_VIEWS = "4 or More Views",
  CARDIAC_DEVICE = "Cardiac Device",
  DIAGNOSTIC = "Diagnostic",
  DOPPLER = "Doppler",
  DUPLEX = "Duplex",
  FLUOROSCOPY = "Fluoroscopy",
  FUNDUS = "Fundus",
  IN_PERSON = "In Person",
  LESS_THAN_4_VIEWS = "Less Than 4 Views",
  LOW_DOSE = "Low-Dose",
  NONVASCULAR = "Nonvascular",
  OBSTETRIC = "Obstetric",
  PAD = "PAD",
  RADIOLOGY_IMAGING = "Radiology/Imaging",
  REMOTE = "Remote",
  SCREENING = "Screening",
  SKULL_BASE_TO_MID_THIGH = "Skull Base to Mid-Thigh",
  STANDARD_GRAYSCALE = "Standard (Grayscale)",
  STRESS = "Stress",
  TRANSESOPHAGEAL = "Transesophageal",
  TRANSVAGINAL = "Transvaginal",
  WITH_CONTRAST = "W/ Contrast",
  WITHOUT_CONTRAST = "W/O Contrast",
  WITH_AND_WITHOUT_CONTRAST = "W/WO Contrast",
  WHOLE_BODY = "Whole Body",
  WITH_GFR = "With GFR",
}
